import React from 'react'
import { DocumentOutlineIcon, PrintOutlineIcon, TruckOutlineIcon } from '@usap/uicomponents'

const SecondInstruction = () => (
  <>
   <TruckOutlineIcon />
    <p>
      <span>
        2. Pack the original item(s) and the Packing Slip inside a box and ship it back to&nbsp;
        <b>
          2821 Marion Dr #111, Las Vegas, NV 89115 
        </b>&nbsp;
        using your preferred shipping carrier
      </span>
    </p>
  </>
)

const ThirdInstruction = ({ itemTotal }) => (
    <>
        <DocumentOutlineIcon />
        <p>
            <span>
            3. Once we&apos;ve received the part, we&apos;ll review and process your claim that estimates to a refund of&nbsp;
            <b>
                $
                {itemTotal}
            </b>
            </span>
        </p>
    </>
)

export const detailInstructionData = {
  header: 'Here’s How to Get Your Lifetime Replacement Refund',
  list: [
    {
      Detail: function Detail() {
        return (
            <>
            <PrintOutlineIcon/>
            <p>
                1. Click the “Submit Claim” button below and print the Packing Slip on the next screen
            </p>
          </>
        )
      },
    },
    {
      Detail: function Detail() {
        return (
            <>
            <TruckOutlineIcon />
          <p>
            <span>
              2. Pack your original item(s) and the Packing Slip inside a box and ship it back to&nbsp;
              <b>
                2821 Marion Dr #111, Las Vegas, NV 89115
              </b>&nbsp;
              using your preferred shipping carrier
            </span>
          </p>
          </>
        )
      },
    },
    {
      Detail: ThirdInstruction,
    },
  ],
}

export const confirmationInstructionData = {
  header: 'Here’s How to Get Your Lifetime Replacement Refund',
  list: [
    {
      Detail: function Detail() {
        return (
          <>
           <PrintOutlineIcon/>
          <p>
            1. Print the Packing Slip by clicking the “Print Packing Slip” button below
          </p>
          </>
        )
      },
    },
    {
      Detail: SecondInstruction,
    },
    {
      Detail: ThirdInstruction,
    },
  ],
}
